import { render, staticRenderFns } from "./Template6.vue?vue&type=template&id=a248ad96"
import script from "./Template6.vue?vue&type=script&lang=js"
export * from "./Template6.vue?vue&type=script&lang=js"
import style0 from "./Template6.vue?vue&type=style&index=0&id=a248ad96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports